import { ISrmAuthenticationContext } from "./srm-authentication-context";

interface ISrmAuthenticationContextReducerLoginPayload {
    action: "login";
    userName: string;
    dropApiToken: string;
    getTokenFn: () => string;
    onLogoutCallback: () => Promise<void>;
}

interface ISrmAuthenticationContextReducerLoginFailedPayload {
    action: "loginFailed";
}

interface ISrmAuthenticationContextReducerLogoutPayload {
    action: "logout";
    onLoginCallback: () => void;
}

type ISrmAuthenticationContextReducerPayload = ISrmAuthenticationContextReducerLoginPayload | ISrmAuthenticationContextReducerLoginFailedPayload
    | ISrmAuthenticationContextReducerLogoutPayload;

export const SrmAuthenticationContextReducer = (context: ISrmAuthenticationContext,
                                                message: ISrmAuthenticationContextReducerPayload): ISrmAuthenticationContext => {
    switch (message.action) {
        case "login":
            return {
                isInitialized: true,
                isAuthenticated: true,
                userName: message.userName,
                getTokenFn: message.getTokenFn,
                dropApiToken: message.dropApiToken,
                logout: message.onLogoutCallback,
            };
        case "loginFailed":
            return {
                isInitialized: true,
                isAuthenticated: false,
                login: () => ({}),
            };
        case "logout":
            return {
                isInitialized: false,
                isAuthenticated: false,
                login: message.onLoginCallback,
            };

        default:
            return context;
    }
};
